const promotions = [
  {
    id: "PROMO5",
    description:
      "Discount 5% of total price for every 5 items purchased, up to a maximum of 40% discount.",

    discountRanges: [
      {
        starting_quantity: 1,
        discountPercentage: 0,
      },
      {
        starting_quantity: 5,
        discountPercentage: 5,
      },
      {
        starting_quantity: 10,
        discountPercentage: 10,
      },
      {
        starting_quantity: 15,
        discountPercentage: 15,
      },
      {
        starting_quantity: 20,
        discountPercentage: 20,
      },
      {
        starting_quantity: 25,
        discountPercentage: 25,
      },
      {
        starting_quantity: 30,
        discountPercentage: 30,
      },
      {
        starting_quantity: 35,
        discountPercentage: 35,
      },
      {
        starting_quantity: 40,
        discountPercentage: 40,
      },
    ],
  },

  {
    id: "PROMO10",
    description:
      "Discount 10% of total price for every 5 items purchased, up to a maximum of 40% discount.",

    discountRanges: [
      {
        starting_quantity: 1,
        discountPercentage: 0,
      },
      {
        starting_quantity: 5,
        discountPercentage: 10,
      },
      {
        starting_quantity: 10,
        discountPercentage: 20,
      },
      {
        starting_quantity: 15,
        discountPercentage: 30,
      },
      {
        starting_quantity: 20,
        discountPercentage: 40,
      },
    ],
  },
];

export default promotions;
